import { residentApi } from "../fetchers";
import { errorResponse } from "../types/response";

export const handleDownload = async () => {
  const response = await residentApi.getTemplate();
  const blob = new Blob([response]);
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `선거인명부 템플릿.xlsx`;
  link.click();
};

export const handleUpload = async ({ e, refetch }) => {
  if (e.target.files) {
    const uploadFile = e.target.files[0];
    const formData = new FormData();
    formData.append("file", uploadFile);

    try {
      await residentApi.registerWithExcel(formData);
      refetch();
    } catch (err: unknown) {
      const customError = err as errorResponse;
      console.error(customError);
      alert(customError.response.data.error.message);
    }
  }
};
